import { NotificationPayloadT } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { withTeams } from 'hocs';

import { notificationActions } from '../../../../components/notifications/actions/notification';
import { TeamsDispatchProps, Teams as TeamsImpl } from '../components';

const mapDispatchToProps = (dispatch: Dispatch): TeamsDispatchProps => ({
  notificationAdd: (payload: NotificationPayloadT) =>
    dispatch(notificationActions.notificationAdd(payload)),
});

const Teams = withTeams(TeamsImpl);

const TeamsConnected = connect(undefined, mapDispatchToProps)(Teams);

export { TeamsConnected as Teams };
